<script setup lang="ts">
import { computed, ref } from 'vue';

import Accordion from '@/components/base/layout/Accordion.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header5 from '@/components/base/typography/Header5.vue';
import Header6 from '@/components/base/typography/Header6.vue';
import RatingStars from '@/components/pdp/reviews/RatingStars.vue';
import { pluralizeBy } from '@/filters/pluralize';
import { ApprovedReviews } from '@/lib/reviews';
import { TypographyTags } from '@/utils/accessibility';

const props = defineProps<{
  headerTag?: TypographyTags;
  reviews: ApprovedReviews;
}>();
const emit = defineEmits(['click']);

const isExpanded = ref(false);
const quantity = computed(() => props.reviews.totalRatings);
const displayText = computed(() => pluralizeBy('Rating', quantity.value));
</script>

<template>
  <Accordion :expanded="isExpanded" :headerTag="headerTag" @update:expanded="emit('click')">
    <template #title>
      <div class="inline-flex items-center">
        <Header5 headerTag="span">Reviews</Header5>
        <RatingStars class="self-center ml-2" :rating="reviews.averageRating" />
        <Header6
          class="flex ml-2 font-semibold text-neutral-500 md:text-black font-sofia-pro"
          headerTag="span"
        >
          <span class="md:hidden">(</span>
          <span>{{ reviews.averageRating.toFixed(1) }}</span>
          <span class="md:hidden">)</span>
        </Header6>
        <BaseBodyText class="hidden ml-2 text-black md:block md:visible font-sofia-pro">
          {{ quantity.toLocaleString() }}
          {{ displayText }}
        </BaseBodyText>
        <BaseBodyText
          v-if="!reviews.totalRatings"
          class="ml-1 text-neutral-500 md:text-black font-sofia-pro"
        >
          (No ratings yet)
        </BaseBodyText>
      </div>
    </template>
  </Accordion>
</template>
